import React from 'react';
import ResultCard from './ResultCard';
import { Link } from 'react-router-dom';
import { tmdbUrl, viaPlaceholderUrl } from '../../../services/resourceURLs';


const SearchResults = props => {
  console.log("searchResults", props);
  if(!props.searchResults.length) {
    return (
      <div className="search-results-container-none" style={{marginTop:"20px", padding: "40px"}}>
        <h4>Your search yielded no results. Please <Link style={{textDecoration:"underline", color: "darkblue"}}to="/">try again.</Link></h4>
      </div>
    )
  }
    return (
      <div className="search-results-container">
        {props.searchResults.map(result => {
          console.log(result, "result of search")
          return (
            <Link to={`/moviereviews/${result.id}`} key={result.id}className="linksMovie">
              <div className = "result-card" key={result.id} index={result.id}>
                <img
                  className="poster-img"
                  src={
                    result.poster_path
                      ? `${tmdbUrl}${result.poster_path}`
                      : `${viaPlaceholderUrl}/300x450.png?text=Photo+Not+Available`
                    // placeholder from : C/O ${viaPlaceholderUrl}/#How_To_Set_Custom_Text"
                  }
                  alt={result.title}
                />
                <h1 className="search-results-header">
                  {`${result.title}`}
                </h1>
                <p>{props.getReleaseYear(result.release_date)}</p>
              </div>
              </Link>
          //   //saving index on result-card so that index is available to query movie details information
          //   // <Link to={`/moviereviews/${result.id}`} key={result.id}className="linksMovie">
          
            // </Link>
          );
        })}
      </div>
    );
};

export default SearchResults;
